<template>
  <div class="whole">
    <div class="button">
      <el-button style="background-color: lightskyblue" @click="upData">{{ $t("button.Pass") }}</el-button>
      <el-button style="background-color: lightsalmon" @click="backData">{{ $t("button.Return") }}</el-button>
    </div>

      <div class="show">
        <el-table
            ref="multipleTable"
            :data="verifyData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange">
          <el-table-column
              prop="uploadtime"
              :label="$t('label.UploadTime')"
              width="160px">
          </el-table-column>

          <el-table-column
              prop="uploader.username"
              :label="$t('label.UploaderUsername')"
              width="100px">
          </el-table-column>

          <el-table-column
              prop="eva_index.year"
              :label="$t('label.IndexYear')"
              width="100px">
          </el-table-column>

          <el-table-column
              v-if="isOk"
              prop="city.name_cn"
              :label="$t('label.CityName')">
          </el-table-column>

          <el-table-column
              v-if="!isOk"
              prop="city.name_en"
              :label="$t('label.CityName')">
          </el-table-column>

          <el-table-column
              v-if="isOk"
              prop="eva_index.name_cn"
              :label="$t('label.IndexName')"
              width="160px">
          </el-table-column>

          <el-table-column
              v-if="!isOk"
              prop="eva_index.name_en"
              :label="$t('label.IndexName')"
              width="160px">
          </el-table-column>

          <el-table-column
              prop="value"
              :label="$t('label.Value')"
              width="160px">
          </el-table-column>

          <el-table-column
              prop="source"
              :label="$t('label.Source')"
              width="150px">
          </el-table-column>

          <el-table-column type="selection" width="55" :label="$t('label.Approved')">
          </el-table-column>

          <template slot="empty">
            <p>{{$t("label.empty")}}</p>
          </template>
        </el-table>
      </div>

    <div class="pagination">
      <el-pagination
          background
          :page-size="pagesize"
          layout="prev, pager, next"
          @current-change="current_change"
          :total="verifyData.length">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "notVerify",
  data(){
    return {
      isOk:'',
      uId:'',
      selection:[],
      verifyData: [],
      pagesize:6,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods:{
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    getNVData(){
      var that=this
      request.get('/confirm/search?state=-1').then(function (res){
        that.verifyData=res.data
      }).catch(function (err){
        console.log(err)
      })
    },
    upData(){
      var that=this
      var updata=[]
      var datadic={}
      //根据选中的数据，每一行进行插入cidata表操作
      //若插入成功，则将其状态改为"完成1"
      //若插入不成功，则不改变其状态
      for(let n=0;n<this.selection.length;n++){
        let select=this.selection[n]
        request.post('/cidata?city_id='+select.city.id+'&eva_index_id='+select.eva_index.id+'&source='+select.source+'&value='+select.value).then(async function (res){
          console.log(res.data)
          if(res.data==true){
            updata=[]
            datadic={}
            datadic.cityId=select.city.id
            datadic.eva_index_id=select.eva_index.id
            updata.push(datadic)
            //改变数据的状态
            await request.put('/confirm?confirmer_id='+that.uId+'&state=1',updata).then(function (result){
              if(result.data===true){
                if(that.isOk===true){
                  alert("审核成功！")
                }
                else{
                  alert("Approval succeeded!")
                }
                location.reload()
              }
            }).then(function (err2){
              console.log(err2,2)
            })
          }
          else{
            if(that.isOk===true){
              alert("该数据不能插入至数据库!")
            }
            else{
              alert("The data cannot be inserted into the database!")
            }
            return false
          }
        }).catch(function (err){
          console.log(err,1)
        })
      }
    },
    backData(){
      var that=this
      var backdata=[]
      var datadic1={}
      for(let i=0;i<that.selection.length;i++){
        datadic1={}
        datadic1.cityId=that.selection[i].city.id
        datadic1.eva_index_id=that.selection[i].eva_index.id
        backdata.push(datadic1)
      }
      request.put('/confirm?confirmer_id='+that.uId+'&state=0',backdata).then(function (res){
        if(res.data===true){
          if(that.isOk===true){
            alert("打回成功！")
          }
          else{
            alert("Return succeeded!")
          }
          location.reload()
        }
      }).catch(function (err){
        console.log(err)
      })
    },
    handleSelectionChange(val){
      this.selection=val
    },
    getUser(){
      let that=this
      request.get('/sysUser/currentUser').then(function(res){
        that.uId=res.data.id
      }).catch(function (err){
        console.log(err)
      })
    }
  },
 mounted() {
   this.getNVData()
   this.getUser()
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.isOk=true
    }
    else{
      this.isOk=false
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.show{
  margin-top: 20px;
  text-align: center;
}
.button{
  margin:10px;
}
</style>